import React, { useState, useEffect } from "react";
import { useParams, NavLink } from "react-router-dom";
import { getBookingsUserById } from "../Services/userService";
import { RoutesPaths } from "../Router/constant";

export default function Bookingmanagementdetail() {
    const { id } = useParams();
    const [bookingUserData, setBookingUserData] = useState(null);
    useEffect(() => {
        if (id) {
            fetchBookingData();
        }
    }, [id]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const orders = bookingUserData?.data?.orders || [];
    const totalPages = Math.ceil(orders.length / itemsPerPage);
    const currentOrders = orders.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const fetchBookingData = async () => {
        try {
            const bookingResp = await getBookingsUserById(id);
            const booking = bookingResp?.data;
            setBookingUserData(booking);
        } catch (error) {
            console.error("Error fetching booking:", error);
        }
    };

    return (
        <div className="container-fluid">
            <div className="row dashboardSection">
                <div className="col-md-12">
                    <div className="col-md-12 bookingDetailsMain">
                        <div className="bookingDetailsOuter">

                            {bookingUserData?.data?.orders?.length > 0 ? (
                                <div className="TableOverFlow">
                                    <div className="bookingContent bookingDetailsHeader">
                                        <div className="m-0 orderIdWidth">Order Id</div>
                                        <div className="m-0 userNameWidth">Customer Name</div>
                                        <div className="m-0 logisticswidth">Phone Number</div>
                                        <div className="m-0 logisticswidth">Currency</div>
                                        <div className="m-0 statusWidth">Date</div>
                                        <div className="m-0 statusWidth">Status</div>
                                        <div className="m-0 statusWidth">Payment Status</div>
                                        <div className="m-0 logisticswidth">Total Products</div>
                                        <div className="m-0 logisticswidth">View Detail</div>

                                    </div>

                                    {currentOrders.map((order, index) => {
                                        const totalProducts = order.productDetails?.length || 0;

                                        return (
                                            <div className="bookingContent bookingContentData" key={`${order._id}-${index}`}>
                                                <div className="m-0 orderIdWidth">#{order.orderId}</div>
                                                <div className="m-0 userNameWidth">{order.name || "N/A"}</div>
                                                <div className="m-0 logisticswidth">{order.phoneNumber}</div>
                                                <div className="m-0 logisticswidth">{order.currency?.toUpperCase()}</div>
                                                <div className="m-0 statusWidth">{new Date(order.createdAt).toLocaleDateString("en-GB")}</div>
                                                <div className="statusWidth">
                                                    <div className={`badgeBooking ${order.status}Badge widthFitContent`}>
                                                        <span>{order.status || "N/A"}</span>
                                                    </div>
                                                </div>
                                                <div className="statusWidth">
                                                    <div className={`badgeBooking ${order.paymentStatus}Badge widthFitContent`}>
                                                        <span>{order.paymentStatus || "N/A"}</span>
                                                    </div>
                                                </div>
                                                <div className="m-0 logisticswidth">{totalProducts}</div>
                                                <div className="m-0 logisticswidth"><NavLink
                                                    to={`${RoutesPaths.BOOKINGMANAGEMENTORDERHISTORY}/${order?._id}`}
                                                    style={{ textDecoration: "none" }}
                                                >
                                                    <button className="viewMore">
                                                        View
                                                    </button>
                                                </NavLink></div>
                                            </div>
                                        );
                                    })}

                                </div>
                            ) : (
                                <p className="noOrders">No order found</p>
                            )}

                            {totalPages > 1 && (
                                <div className="paginationSection d-flex align-items-center justify-content-center gap-2 mt-3">
                                    <p onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)} style={{ cursor: "pointer" }}>
                                        <img src="/assets/img/arrow-left.svg" alt="Previous" />
                                    </p>

                                    {[...Array(totalPages)].map((_, index) => (
                                        <p
                                            key={index}
                                            onClick={() => setCurrentPage(index + 1)}
                                            style={{
                                                fontWeight: currentPage === index + 1 ? "bold" : "normal",
                                                cursor: "pointer",
                                                margin: "0 5px",
                                            }}
                                        >
                                            {index + 1}
                                        </p>
                                    ))}

                                    <p onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)} style={{ cursor: "pointer" }}>
                                        <img src="/assets/img/arrow-right.svg" alt="Next" />
                                    </p>
                                </div>
                            )}

                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
}
